import React from 'react';

import { SVGComponentProps } from './svg.types';

const LmsMenuSVG = ({ fill = '#878A92', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 12"
      fill={fill}
      {...otherProps}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9173_18132)">
        <path
          d="M19.1343 0.660156H8.86571C8.63793 0.661254 8.41966 0.751643 8.25779 0.91191C8.09592 1.07218 8.00336 1.28954 8 1.5173V1.86873C8.00045 2.09811 8.09184 2.31796 8.25411 2.48008C8.41639 2.64219 8.63633 2.73336 8.86571 2.73358H19.1343C19.3637 2.73336 19.5836 2.64219 19.7459 2.48008C19.9082 2.31796 19.9995 2.09811 20 1.86873V1.51901C19.9971 1.29095 19.9047 1.07316 19.7428 0.912522C19.5809 0.751887 19.3624 0.661261 19.1343 0.660156Z"
          fill={fill}
        />
        <path
          d="M19.1343 4.88574H8.86571C8.63793 4.88684 8.41966 4.97723 8.25779 5.1375C8.09592 5.29776 8.00336 5.51512 8 5.74289V6.09174C8.00023 6.32127 8.09151 6.54134 8.25381 6.70364C8.41612 6.86595 8.63618 6.95723 8.86571 6.95746H19.1343C19.3629 6.95724 19.5822 6.86666 19.7444 6.70547C19.9065 6.54427 19.9984 6.32552 20 6.09689V5.74717C19.998 5.51859 19.906 5.30001 19.7439 5.13878C19.5819 4.97754 19.3629 4.88663 19.1343 4.88574Z"
          fill={fill}
        />
        <path
          d="M19.1317 9.11768H8.86571C8.63793 9.11877 8.41966 9.20916 8.25779 9.36943C8.09592 9.5297 8.00336 9.74706 8 9.97482V10.3228C8.00023 10.5524 8.09151 10.7724 8.25381 10.9347C8.41612 11.097 8.63618 11.1883 8.86571 11.1885H19.1317C19.3612 11.189 19.5816 11.0984 19.7444 10.9365C19.9072 10.7747 19.9991 10.5549 20 10.3254V9.97653C19.9973 9.74796 19.9046 9.52965 19.7421 9.3689C19.5796 9.20814 19.3603 9.11789 19.1317 9.11768Z"
          fill={fill}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.2167 9.38805C6.21871 9.15247 6.12687 8.92493 5.95972 8.75135L3.22806 6.00007L5.95972 3.24879C6.12709 3.07572 6.22001 2.84898 6.22001 2.61362C6.22001 2.37827 6.12709 2.15152 5.95972 1.97845C5.87968 1.89522 5.78234 1.82876 5.6739 1.7833C5.56546 1.73783 5.44828 1.71436 5.32981 1.71436C5.21134 1.71436 5.09416 1.73783 4.98572 1.7833C4.87728 1.82876 4.77994 1.89522 4.69989 1.97845L1.33863 5.36521C1.17056 5.53758 1.07715 5.76416 1.07715 5.99946C1.07715 6.23475 1.17056 6.46134 1.33863 6.63371L4.69668 10.0217C4.77673 10.1049 4.87406 10.1714 4.9825 10.2168C5.09095 10.2623 5.20812 10.2858 5.3266 10.2858C5.44507 10.2858 5.56225 10.2623 5.67069 10.2168C5.77913 10.1714 5.87647 10.1049 5.95651 10.0217C6.12345 9.84921 6.21532 9.62269 6.21349 9.38805"
        fill={fill}
      />
      <defs>
        <clipPath id="clip0_9173_18132">
          <rect width="12" height="12" fill="white" transform="translate(8)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LmsMenuSVG;
